import type { TNotesType } from "components/Dashboard/DoctorDashboard/notes-and-forms/types";
import { getErrorDetail } from "components/utility/utils";
import { parseRawTemplateResponse } from "notes-and-forms-v2/util/convertTemplateToV2";
import { fetchOrchidAPI } from "utils/api";
import getNoteOrFormSchemaDB from "./utils/getNoteOrFormSchemaDB";

export default async function createNoteOrFormSchema<T extends TNotesType>(
  type: T,
  arg: T extends "note"
    ? Pick<
        NoteSchema,
        | "note_ui_schema"
        | "note_json_schema"
        | "schema_v2"
        | "pdf_conversion_job_id"
        | "note_schema_type"
      >
    : Pick<
        FormSchema,
        | "form_ui_schema"
        | "form_json_schema"
        | "schema_v2"
        | "pdf_conversion_job_id"
      >,
): Promise<T extends "note" ? NoteSchema : FormSchema> {
  const uiField = `${type}_ui_schema`;
  const jsonField = `${type}_json_schema`;

  const res = await fetchOrchidAPI(
    `/api/${getNoteOrFormSchemaDB(type)}/v1/${type}s/schema/`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ...arg,
        [uiField]: !arg[uiField] ? arg[uiField] : JSON.stringify(arg[uiField]),
        [jsonField]: !arg[jsonField]
          ? arg[jsonField]
          : JSON.stringify(arg[jsonField]),
        schema_v2: JSON.stringify(arg.schema_v2),
        pdf_conversion_job_id: arg.pdf_conversion_job_id ?? "",
      }),
    },
  );

  if (!res.ok) {
    throw new Error(
      `failed to create ${type} schema: ${getErrorDetail(await res.text())}`,
    );
  }

  const raw = await res.json();
  if (!raw) {
    return raw;
  }

  return parseRawTemplateResponse(type, raw);
}
